import { render, staticRenderFns } from "./DatatypesTable.vue?vue&type=template&id=03b2cebb&"
import script from "./DatatypesTable.vue?vue&type=script&lang=js&"
export * from "./DatatypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports